var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSorted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9273 13.1777L11.4969 15.5345L9.06644 13.1777C8.82215 12.9408 8.42752 12.9408 8.18322 13.1777C7.93893 13.4146 7.93893 13.7973 8.18322 14.0342L11.0584 16.8223C11.3027 17.0592 11.6973 17.0592 11.9416 16.8223L14.8168 14.0342C15.0611 13.7973 15.0611 13.4146 14.8168 13.1777C14.5725 12.9468 14.1716 12.9408 13.9273 13.1777Z",
    fill: "#353434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07271 9.82232L11.5031 7.46545L13.9336 9.82232C14.1779 10.0592 14.5725 10.0592 14.8168 9.82232C15.0611 9.58542 15.0611 9.20273 14.8168 8.96583L11.9416 6.17768C11.6973 5.94077 11.3027 5.94077 11.0584 6.17768L8.18322 8.96583C7.93893 9.20274 7.93893 9.58542 8.18322 9.82233C8.42752 10.0532 8.82841 10.0592 9.07271 9.82232Z",
    fill: "#353434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSorted);
export default __webpack_public_path__ + "static/media/no-sorted.635240e9d50b9b99f4d2fe0da6ac0218.svg";
export { ForwardRef as ReactComponent };